import { logger } from "@otto-ec/global-resources/debug";
const log = logger("hopper:auction-otter");
export { log };
